// JS
import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import usePageData from '../shared/usePageData';
import { randomId } from '../shared/utils';

// COMPONENTS
import NewArrivalsSlider from '../NewArrivalsSlider';

// COMPONENT
const NewArrivals = ({
  newArrivalsHeading = 'New Arrivals',
  newArrivalsSubHeading = 'Shop the latest drops',
  gaBlockName,
  gaBlockNameAll,
  gaBlockNameClothing,
  gaBlockNameFootwear,
  gaBlockNameAccessories,
  blackFriday,
  blackFridaySubText,
  blackFridayBadge,
  newArrivalsOptions,
  isSeventhImage,
  newArrivalsButtonLinkAll,
  newArrivalsButtonLinkClothing,
  newArrivalsButtonLinkFootwear,
  newArrivalsButtonLinkAcc,
  newArrivalsAllFeed,
  newArrivalsClothingFeed,
  newArrivalsFootwearFeed,
  newArrivalsAccessoriesFeed
}) => {
  const uniqueId = randomId();

  return (
    <section
      id={'new-arrivals-section-' + uniqueId}
      className={
        'container my-24 lg:my-48' +
        (newArrivalsOptions?.classes ? ' ' + newArrivalsOptions.classes : '')
      }
    >
      <Tabs
        data-name={'New Arrivals'}
        data-creative={gaBlockName}
        data-id={'new-arrivals-' + uniqueId}
        data-position={'banner-slot-1'}
        data-type="banner"
      >
        <TabList
          className={`list-none flex flex-col md:flex-row items-center justify-between text-xs md:text-base uppercase font-base gap-y-6 mb-8 first-letter first-letter 
          ${blackFriday && '!items-start'}`}
        >
          <h2
            className={`text-xl text-center font-semibold uppercase md:text-left 
            ${
              blackFriday &&
              'font-sans tracking-normal !text-lg font-bold leading-normal capitalize'
            }`}
          >
            {newArrivalsHeading}
            {blackFridaySubText && (
              <span className="block font-base text-md md:text-lg">
                {newArrivalsSubHeading}
              </span>
            )}
          </h2>
          <div className="flex flex-row gap-x-9 md:gap-x-14">
            <Tab>All</Tab>
            <Tab>Clothing</Tab>
            <Tab>Footwear</Tab>
            <Tab>Accessories</Tab>
          </div>
        </TabList>
        <TabPanel>
          <NewArrivalsSlider
            getProductData={usePageData(newArrivalsAllFeed, '0', 'feed')}
            newArrivalsButtonLink={newArrivalsButtonLinkAll}
            gaBlockName={gaBlockName}
            blackFriday={blackFriday}
            blackFridayBadge={blackFridayBadge}
            isSeventhImage={isSeventhImage}
          />
        </TabPanel>
        <TabPanel
          data-name={'New Arrivals Clothing'}
          data-creative={gaBlockNameClothing}
          data-id={'new-arrivals-clothing-' + uniqueId}
          data-position={'banner-slot-2'}
          data-type="banner"
        >
          <NewArrivalsSlider
            getProductData={usePageData(newArrivalsClothingFeed, '0', 'feed')}
            newArrivalsButtonLink={newArrivalsButtonLinkClothing}
            gaBlockName={gaBlockNameClothing}
            blackFriday={blackFriday}
            blackFridayBadge={blackFridayBadge}
          />
        </TabPanel>
        <TabPanel
          data-name={'New Arrivals Footwear'}
          data-creative={gaBlockNameFootwear}
          data-id={'new-arrivals-footwear-' + uniqueId}
          data-position={'banner-slot-3'}
          data-type="banner"
        >
          <NewArrivalsSlider
            getProductData={usePageData(newArrivalsFootwearFeed, '0', 'feed')}
            newArrivalsButtonLink={newArrivalsButtonLinkFootwear}
            gaBlockName={gaBlockNameFootwear}
            blackFriday={blackFriday}
            blackFridayBadge={blackFridayBadge}
          />
        </TabPanel>
        <TabPanel
          data-name={'New Arrivals Accessories'}
          data-creative={gaBlockNameAccessories}
          data-id={'new-arrivals-accessories-' + uniqueId}
          data-position={'banner-slot-4'}
          data-type="banner"
        >
          <NewArrivalsSlider
            getProductData={usePageData(
              newArrivalsAccessoriesFeed,
              '0',
              'feed'
            )}
            newArrivalsButtonLink={newArrivalsButtonLinkAcc}
            gaBlockName={gaBlockNameAccessories}
            blackFriday={blackFriday}
            blackFridayBadge={blackFridayBadge}
          />
        </TabPanel>
      </Tabs>
    </section>
  );
};

export default NewArrivals;
